import { style } from '@angular/animations';


export const slideLeft = [
  style({transform: 'translate3d(-100%, 0, 0)', offset: .5}),
  style({transform: 'translate3d(0, 0, 0)', offset: 1})
];
export const slideRight = [
  style({transform: 'translate3d(+100%, 0, 0)', offset: .5}),
  style({transform: 'translate3d(0, 0, 0)', offset: 1})
];

export const slideLeftFab = [
  style({transform: 'translate3d(-1000px, 0, 0)', offset: .1}),
  style({transform: 'translate3d(0, 0, 0)', offset: 1})
];
export const slideRightFab = [
  style({transform: 'translate3d(+1000px, 0, 0)', offset: .1}),
  style({transform: 'translate3d(0, 0, 0)', offset: 1})
];
